import { render, staticRenderFns } from "./LoteCardVertical.vue?vue&type=template&id=c299b712&scoped=true"
import script from "./LoteCardVertical.vue?vue&type=script&lang=js"
export * from "./LoteCardVertical.vue?vue&type=script&lang=js"
import style0 from "./LoteCardVertical.vue?vue&type=style&index=0&id=c299b712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c299b712",
  null
  
)

export default component.exports